import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  status() {
    return faker.datatype.number({
      min: 1,
      max: 2,
    });
  },

  lastScanStart() {
    return faker.lorem.sentence();
  },

  lastScanEnd() {
    const typeOptions = ['shop', 'website'];

    return faker.helpers.arrayElement(typeOptions);
  },

  violationsTotal() {
    return faker.datatype.number({
      min: 10,
      max: 1000,
    });
  },

  violationsA() {
    return faker.datatype.number({
      min: 10,
      max: 1000,
    });
  },

  violationsAA() {
    return faker.datatype.number({
      min: 10,
      max: 1000,
    });
  },

  violationsAAA() {
    return faker.datatype.number({
      min: 10,
      max: 1000,
    });
  },

  scoreTotal() {
    return faker.datatype.number({
      min: 0,
      max: 100,
    });
  },

  errorCount() {
    return faker.datatype.number({
      min: 10,
      max: 1000,
    });
  },

  timeEstimation() {
    return 0;
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsModified() {
    return faker.date.past();
  },
});
